<mat-form-field
  appearance="fill"
  class="text--body full-width-field test"
  data-test="registration-search"
>
  <input
    #search
    type="text"
    [placeholder]="'search' | translate"
    [formControl]="searchControl"
    matInput
    data-test="registration-search-input"
  />
</mat-form-field>
